// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Wrapper = styled.li`
  list-style: none;
  padding: 6px 24px;
  ${props => props.hasBorder &&
    css`
      border-top: 1px solid ${props.theme.colors.neutral.grey[2]};
      padding: 26px 24px;
    `}
`;

const Button = styled.button`
  display: flex;
  width: 100%;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral.currysBlack};
  text-decoration: none;
  padding: 6px 0;
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-family: ${({ theme }) => theme.fonts.default.fontFamily}, Helvetica, Arial, Sans-Serif;

  &:hover {
    text-decoration: underline;
  }
`;

const Link = styled.a`
  display: flex;
  color: ${({ theme }) => theme.colors.neutral.currysBlack};
  text-decoration: none;
  padding: 6px 0;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const Label = styled.span`
  flex: 1;
  font-size: 14px;
  line-height: 24px;
`;

const LeftIcon = styled(Icon)`
  margin-right: 15px;
`;

const RightIcon = styled(Icon)`
  margin-left: 15px;
`;

const NavigationItem = (props) => {
  const NavigationButtonEl = props.onNavigationClick ? Button : Link;

  return (
    <Wrapper hasBorder={props.hasBorder}>
      <NavigationButtonEl
        href={props.onNavigationClick ? '' : props.link}
        onClick={props.onNavigationClick}
      >
        {props.icon && <LeftIcon icon={props.icon} />}
        <Label>{props.label}</Label>
        {props.onNavigationClick ? <RightIcon icon="arrowright" /> : null}
      </NavigationButtonEl>
    </Wrapper>
  );
};

NavigationItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  onNavigationClick: PropTypes.func,
  hasBorder: PropTypes.bool
};

NavigationItem.defaultProps = {
  label: '',
  icon: '',
  link: '',
  onNavigationClick: null,
  hasBorder: false
};

export default NavigationItem;
